<!-- Adapted from YesPlayMusic v0.4.11, MIT (qier222). views/dailyTracks.vue -->
<template>
  <section v-if="salt" class="salt-daily-page"><h1>每日歌曲推荐</h1><SaltCard><SaltItem title="每日推荐暂不可用" description="当前来源未提供每日推荐接口。" /><SaltItem title="浏览发现" clickable arrow="arrow" @click="$router.push('/explore')" /></SaltCard></section>
  <div v-else>
    <div class="special-playlist">
      <div class="title gradient">每日歌曲推荐</div>
      <div class="subtitle">需要网易云账号 · 当前部署尚未接入账号登录</div>
      <div class="buttons">
        <ButtonTwoTone class="play-button" icon-class="play" color="grey" disabled title="每日推荐需要网易云账号">播放</ButtonTwoTone>
      </div>
    </div>
    <TrackList :tracks="dailyTracks" type="playlist" />
  </div>
</template>

<script>
import ButtonTwoTone from '../components/ButtonTwoTone.vue';
import TrackList from '../components/TrackList.vue';
import { workspace } from '../workspace';
import SaltCard from '../salt/ui/SaltCard.vue';
import SaltItem from '../salt/ui/SaltItem.vue';

export default {
  name: 'DailyTracks',
  components: { ButtonTwoTone, TrackList, SaltCard, SaltItem },
  data() {
    return { workspace, dailyTracks: [] };
  },
  computed:{salt(){return this.workspace.appearance==='salt';}},
};
</script>

<style lang="scss" scoped>
.salt-daily-page h1 { margin:0 0 20px;font-size:24px;font-weight:400;color:var(--salt-text); }
.special-playlist {
  margin-top: 192px;
  margin-bottom: 128px;
  border-radius: 1.25em;
  text-align: center;

  @keyframes letterSpacing4 {
    from { letter-spacing: 0px; }
    to { letter-spacing: 4px; }
  }
  @keyframes letterSpacing1 {
    from { letter-spacing: 0px; }
    to { letter-spacing: 1px; }
  }
  .title {
    font-size: 84px;
    line-height: 1.05;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 4px;
    animation-duration: 0.8s;
    animation-name: letterSpacing4;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    img {
      height: 78px;
      border-radius: 0.125em;
      margin-right: 24px;
    }
  }
  .subtitle {
    font-size: 18px;
    letter-spacing: 1px;
    margin: 28px 0 54px 0;
    animation-duration: 0.8s;
    animation-name: letterSpacing1;
    text-transform: uppercase;
    color: var(--color-text);
  }
  .buttons {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    button { margin-right: 16px; }
  }
}
.gradient { background: linear-gradient(to left, #dd2476, #ff512f); }
@media (max-width: 760px) {
  .special-playlist { margin-top: 96px; margin-bottom: 64px; }
  .special-playlist .title { font-size: 54px; }
}
</style>
